import React from 'lib/react';
import { EVGrid, EVTypography, EVChip } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { getStatusValues } from 'features/orderHistory/OrderHistory.utils';
import PropTypes from 'prop-types';
import { STATUSES } from 'constants/AppConstants';
import ReportDetailsStyles from './ReportDetailsStyles';

function ReportDetails({ reportId, reportDetails, reportFacets }) {
  const classes = ReportDetailsStyles();
  const { t } = useTranslation();

  const {
    reportAddress: {
      address, address2, city, state, zip,
    },
    reportType,
    orderPlacedDate,
    statusID,
  } = reportDetails;

  const statusName = Object.keys(STATUSES).find((key) => STATUSES[key] === statusID);

  const statusValues = getStatusValues(t);

  return (
    <EVGrid className={classes.detailsGrid}>
      <EVGrid className={classes.detailsHeader}>
        <EVGrid style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <EVTypography className={classes.detailsHeaderTitleText}>
            {t('report_details__title_header')}
          </EVTypography>
          {(reportFacets.length === '') && (
          <EVChip
            className={classes.chipElement}
            style={{
              backgroundColor: statusValues[statusName]?.backgroundColor || '#C8CDD7',
              color: statusValues[statusName]?.color || '#4D5365',
            }}
            label={statusName}
          />
          )}
        </EVGrid>
        <EVTypography className={classes.detailsHeaderContentText}>
          {t('pitch_editor__sub_title')}
        </EVTypography>
      </EVGrid>
      <EVGrid container className={classes.detailsContent}>
        <EVGrid className={classes.detailsContentContainer}>
          <EVTypography className={classes.detailsContentTitleText}>
            {t('pitch_editor__report_type')}
          </EVTypography>
          <EVTypography className={classes.detailsHeaderContentText}>
            {reportType}
          </EVTypography>
        </EVGrid>
        <EVGrid className={classes.detailsContentContainer}>
          <EVTypography className={classes.detailsContentTitleText}>
            {t('order_history__report_id')}
          </EVTypography>
          <EVTypography className={classes.detailsHeaderContentText}>
            {reportId}
          </EVTypography>
        </EVGrid>
        <EVGrid className={classes.detailsContentContainer}>
          <EVTypography className={classes.detailsContentTitleText}>
            {t('pitch_editor__report_date')}
          </EVTypography>
          <EVTypography className={classes.detailsHeaderContentText}>
            {new Date(orderPlacedDate).toLocaleString()}
          </EVTypography>
        </EVGrid>
        {(reportFacets.length !== '') && (
        <EVGrid className={classes.detailsContentContainer}>
          <EVTypography className={classes.detailsContentTitleText}>
            {t('pitch_editor__planes')}
          </EVTypography>
          <EVTypography className={classes.detailsHeaderContentText}>
            {reportFacets.length}
          </EVTypography>

        </EVGrid>
        )}
        <EVGrid className={classes.detailsContentContainer}>
          <EVTypography className={classes.detailsContentTitleText}>
            {t('order_submitted__address')}
          </EVTypography>
          <EVTypography nowrap="true" className={classes.detailsHeaderContentText}>
            {address}
            <br />
            {address2 || `${city}, ${state} ${zip}`}
          </EVTypography>
        </EVGrid>
      </EVGrid>
    </EVGrid>
  );
}

ReportDetails.propTypes = {
  reportDetails: PropTypes.shape().isRequired,
  reportId: PropTypes.string.isRequired,
  reportFacets: PropTypes.shape(),
};

ReportDetails.defaultProps = {
  reportFacets: { length: '' },
};

export default ReportDetails;
